"use client";

import { useTranslation } from "react-i18next";
import Button from "@/components/library/Button";

interface ConfirmExitStepProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmExitStep({
  onConfirm,
  onCancel,
}: Readonly<ConfirmExitStepProps>) {
  const { t } = useTranslation("onboarding");

  return (
    <div className="flex flex-col items-center justify-center h-full gap-8 max-w-lg mx-auto text-center py-12">
      <div className="space-y-4">
        <h1 className="text-2xl md:text-3xl font-medium">
          {t("confirmExit.title")}
        </h1>
        <p className="text-500 text-lg">{t("confirmExit.description")}</p>
      </div>

      <div className="flex flex-col gap-3 w-full max-w-xs">
        <Button onClick={onCancel} className="w-full">
          {t("confirmExit.cancelButton")}
        </Button>
        <Button onClick={onConfirm} type="secondary" className="w-full">
          {t("confirmExit.confirmButton")}
        </Button>
      </div>
    </div>
  );
}
